//status from EZcap
export enum StatusCode {
	APPROVED = 1,
  MODIFIED = 2,
  DENIED = 3,
  DEFERRED = 4,
  EXPIRED = 5,
  CANCELLED = 6,
  REQUESTED = 7,
  SYSTEM_HOLD = 8,
  PENDED = 9
};

export enum PacStatus {
  OPEN = 1,
  PENDING = 2,
  COMPLETED = 3
}

export enum HealthCodes {
  DIABETES = 'Diabetes',
  HYPERTENSION = 'Hypertension',
  LANGUAGE = 'Language',
  LMP = 'Lmp',
  NEW_PATIENT = 'New Patient',
  OSTEOPOROSIS = 'Osteoporosis',
  PREGNANT = 'Pregnant',
  RHEUMATOID_ARTHRITIS = 'Rheumatoid Arthritis',
  SMOKER = 'Smoker',
}

export enum ReferenceCode {
  A = 1,
  B = 2,
  C = 3,
  D = 4,
  E = 5,
  F = 6,
  G = 7,
  H = 8,
  I = 9,
  J = 10,
  K = 11,
  L = 12
}

export enum UserRole {
  ADMIN = '1',
  PROVIDER = '2',
  RISK_GROUP = '3',
  HEALTH_PLAN = '4',
  QCIT = '5',
  CASE = '6',
  IPA = '7',
  THIRD_PARTY = '8'
}

export enum NoteAction {
  I = 'Inserted' as any,
  U = 'Updated' as any,
  D = 'Deleted' as any
}

export enum LineOfBusiness {
  COMMERCIAL = 'COMMERCIAL',
  MEDICARE = 'MEDICARE',
  MEDICAL = 'MEDICAL',
  ALL = 'ALL',
}

export enum CarePlan {
  POST_ACUTE_CARE_PLANS = 'Post Acute Care Plans',
  POST_ACUTE_CARE_NOTES = 'Post Acute Care Notes',
  CARE_PLANS_DOCUMENTS = 'Post Acute Care Documents',
  PLANS = 'Plans',
  NOTES = 'Notes',
  DOCUMENTS = 'Documents',
  PLAN = 'plan',
  NOTE = 'note',
  DOC = 'doc'
}

export enum DocumentCategory {
  OPEN_AUTHS = 'Open Auths',
  CONSULT_NOTES = 'Consult Notes',
  CASE_DOCUMENTS = 'Case Documents',
  CCS_AGING_OUT_DOCUMENTS = 'CCS Aging Out Documents',
  RESCIND_NOTICE = 'Rescind Notice',
  MEMBER_ROSTER = 'Member Roster',
  MEMOS = 'Memos',
  MISC = 'Miscellaneous',
}

export enum DocType {
  DOCUMENTS = 'Documents'
}

export enum SuspectedCondition {
  AGREE = 'A',
  DISAGREE = 'D'
}

export enum HealthCondition {
  CHRONIC = 'C',
  SUSPECTED = 'Z',
  ACUTE = 'A'
}

export enum DiagsStatusCode {
  ACTIVE = 'A',
  DISAGREE = 'D',
  RESOLVED = 'R',
  UNCONFIRMED = 'U'
}

export enum CMWorkListStatus {
  OPEN = 1,
  PENDING = 2,
  COMPLETED = 3
}

export enum CMWorkListAcuity {
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3
}

export enum Color {
  APPROVED ='#36B37E',
  MODIFIED = '#57D9A3',
  DEFERRED = '#8777D9',
  CANCELLED = '#ff7875',
  REQUESTED = '#ffc069',
  REQUESTED_TEXT = 'black',
  EXPIRED = '#C1C7D0',
  DENIED = '#FF5630',
  SYSTEM_HOLD = '#ff9c6e',
  SYSTEM_HOLD_TEXT = 'black',
  PENDED = '#610b00',
}

export enum Company {
  APC ='APC',
  ADV = 'ADV',
  APAACO ='APAACO',
  APCMG = 'APCMG',
  AVISTA ='AVISTA',
  CVIPA = 'CVIPA',
  GAMC ='GAMC',
  GOM = 'GOM',
  GSGP ='GSGP',
  WMMC = 'WMMC',
  AHC ='AHC',
  ALPHA = 'ALPHA',
  BA ='BAIPA',
  CFC = 'CFC',
  JADE ='JADE',
  LSMA = 'LSMA',
  EHIPA = 'EHIPA',
  CVMG = 'CVMG',
  ACPAZ = "ACPAZ",
  BACP = "BACP",
  AMTX = 'AMTX',
  AMNV = 'AMNV',
  MDPTN = 'MDPTN'
}

export enum ResubCodes {
  ORIGINAL = '1',
  REPLACEMENT = '7',
  VOID = '8',
}

export enum ModalTitles {
  AUTH_REQUEST_BLOCKED = "Request for Authorization Not Submitted",
  MEASURE_UPDATE_BLOCKED = "Window for updating measures for selected year has expired",
}

export enum ProviderType {
  PCP = 'P',
  CLINIC = 'C',
}

export enum PortalHelp {
  MESSAGE = "If you need help accessing the Provider Portal, please send an email to Portal.Inquiries@astranahealth.com. "
  +  "Include a description of your issue, your name, and phone number, and an agent will contact you within 24 hours. "
  + "For all other needs please contact the Customer Service line at (626) 282-0288."
}

export enum Filename {
  FaxOutOptReport = 'Web Pilot Posting Report.xlsx'
}

export enum FileDownloadMessage {
  Success = 'Success! File has downloaded.',
  Error = 'Something went wrong, please contact a system administrator.'
}

export enum Application {
  ProviderPortal = 'provider-portal'
}

export enum ClaimList {
  SubmittedClaimMaxLimit = 1000,
  SubmittedBatchClaimMaxLimit = 100,
  SearchClaimMaxLimit = 500
}

export enum AttestationAttributes {
  PNOForm = 'PNOForm.pdf',
  NewProviderOrientationDock = 'NewProviderOrientationDeck.pptx',
  GeneralTraining2022 = '1',
  GeneralTraining2023To202X = '2',
  PNOAttestationTypeId = '3',
  GeneralTrainingAttestation = 'ANNUAL PROVIDER TRAINING ATTESTATION',
  PNOAttestation = 'MOLINA HEALTHCARE OF CALIFORNIA'
}

export enum AttestationReportTitles {
  attestation1 = 'General Training Attestation',
  attestation3 = 'PNO Attestation'
}

export enum Year {
  year2022 = '2022',
  year2023 = '2023'
}

export enum AuthAccess {
  READWRITE = 'Read Write',
  READONLY = 'Read Only'
}

export enum ClickEvents {
  MEMBER_OVERVIEW_NEW = "Click_Member_Overview_New",
  MEMBER_OVERVIEW_TERMED = "Click_Member_Overview_Termed",
  MEMBER_OVERVIEW_IHA = "Click_Member_Overview_IHA",
  MEMBER_MEASURE_IMPROVEMENT = "Click_Member_Measure_Improvement",
  MEMBER_SEARCH = "Click_Member_Search",
  EXPAND_MEASURE = "Expand_GetMeasureMembers",
  PRINT_MEASURE_REPORT = "GetMeasureReportPrintFile",
  DOWNLOAD_HEDIS_GAP_REPORT = "Download_Hedis_Gap_Report",
  DOWNLOAD_HCC_GAP_REPORT = "Download_HCC_Gap_Report",
  PRINT_PAF = "Print_PAF"
}